import { render, staticRenderFns } from "./horizontalAlignEven.vue?vue&type=template&id=8da59f96&"
import script from "./horizontalAlignEven.vue?vue&type=script&lang=ts&"
export * from "./horizontalAlignEven.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports